module.exports = __webpack_public_path__ + "static/media/delete.2f946840.svg";